import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Grid, TextField, MenuItem, FormControl, InputLabel, Select, Button, Avatar } from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import useAutocomplete from '@mui/material/useAutocomplete';
import "react-datepicker/dist/react-datepicker.css"; // Add this line
import { Colors, useStyles } from '../../assets/styles.js';
import logo_icon from '../../assets/images/logo_icon.png'
import * as TestimonialsActions from '../../redux/actions/testimonialsAction.js';

const AddTestimonials = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [testimonialsDetail, setTestimonialsDetail] = useState({ name: '', designation: '', institution: '', description: '', status: '' });
  const [inputFieldError, setInputFieldError] = useState({ name: "Please Provide Name", email: "Please Provide Email" });
  const [testimonialsImage, setTestimonialsImage] = useState({ file: logo_icon, bytes: "" });

  //* Handle Input Field : Error
  const handleInputFieldError = (input, value) => {
    setInputFieldError((prev) => ({ ...prev, [input]: value }))
  }

  //* Handle Input Field : Data
  const handleInputField = (e) => {
    const { name, value } = e.target;
    setTestimonialsDetail({ ...testimonialsDetail, [name]: value });
  };

  //* Handle Testimonials Image
  const handleTestimonialsImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setTestimonialsImage({
        file: URL.createObjectURL(e.target.files[0]),
        bytes: e.target.files[0],
      });
    }
  };

  //! Handle Submit - Creating Testimonials
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Testimonials Data :: ", { ...testimonialsDetail, testimonialsImage })
    const { name, designation, institution, description, status } = testimonialsDetail;

    let formData = new FormData()
    formData.append("name", name)
    formData.append("designation", designation)
    formData.append("institution", institution)
    formData.append("description", description)
    formData.append("status", status);
    formData.append("testimonialImage", testimonialsImage.bytes);

    const payload = {
      data: formData,
      onComplete: () => navigate("/testimonials")
    }

    //! Dispatching API for creating Testimonials
    dispatch(TestimonialsActions.createTestimonials(payload))
  };

  return (

    <>
      <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
          <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>Add Testimonials</div>
          <div onClick={() => navigate("/testimonials")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", fontSize: "14px" }}>Display</div>
        </div>

        <Grid container sx={{ alignItems: "center" }} spacing={3}>
          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Name" variant='outlined' fullWidth
              name='name'
              value={testimonialsDetail?.name}
              onChange={handleInputField}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Designation" variant='outlined' fullWidth
              name='designation'
              value={testimonialsDetail?.designation}
              onChange={handleInputField}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Institution" variant='outlined' fullWidth
              name='institution'
              value={testimonialsDetail?.institution}
              onChange={handleInputField}
            />
          </Grid>

          <Grid item lg={1} sm={6} md={6} xs={6} >
            <Avatar
              color={Colors.primaryDark}
              src={testimonialsImage.file}
              style={{ width: 40, height: 40 }}
            />
          </Grid>
          <Grid item lg={5} sm={6} md={6} xs={6} className={classes.uploadContainer}   >
            <Grid component="label" className={classes.uploadImageButton}>
              Upload Testimonials Image
              <input onChange={handleTestimonialsImage} hidden accept="image/*" type="file" />
            </Grid>
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Description" variant='outlined' fullWidth
              name='description'
              value={testimonialsDetail?.description}
              onChange={handleInputField}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Status</InputLabel>
              <Select
                label="Select Status" variant="outlined" fullWidth
                name='status'
                value={testimonialsDetail?.status}
                onChange={handleInputField}
              >
                <MenuItem disabled>---Select Status---</MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item>
            <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
          </Grid>

        </Grid>
      </div>
    </>

  );
};

export default AddTestimonials;